export default __webpack_public_path__ + "static/media/Buying.d0b27ad9.webp";